module.exports = __webpack_public_path__ + "img/partners-blockchain.6e8b9583.png";